<template>
  <div class="text-center">
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title
          class="headline d-flex justify-space-between align-center"
        >
          <span>Recomendar o referir proveedor</span>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="form.name"
              label="Nombre del proveedor"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              v-model="form.phone"
              label="Teléfono del proveedor"
              :rules="rules.phone"
              outlined
              autocomplete="off"
              maxlength="10"
              dense
              @keypress="validateNumberInput"
            >
              <template v-slot:prepend-inner>
                <span style="margin-top: 3px; display: inline-block">+52</span>
              </template>
            </v-text-field>
            <v-textarea
              v-model="form.notes"
              label="Notas (opcional)"
              outlined
              dense
              rows="3"
              hide-details
            ></v-textarea>

            <div class="caption mt-1">
              <v-icon small color=" lighten-1">mdi-information</v-icon>
              Describe productos, especialidades o razones por las que
              recomiendas este proveedor
            </div>

            <div class="red--text mt-3">{{ errorMessage }}</div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="d-flex justify-end">
          <v-btn text color="black" @click="closeDialog" outlined
            >Cancelar</v-btn
          >
          <v-btn
            class="black white--text"
            :loading="loading"
            :disabled="!valid || loading"
            @click="submitForm"
          >
            <v-icon left>mdi-account-plus</v-icon> Recomendar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CustomerService from "../services/customerService";
import UserManager from "../services/manager/UserManager";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isVisible: this.visible,
      valid: false,
      loading: false,
      errorMessage: "",
      form: {
        name: "",
        phone: "",
        notes: "",
      },
      rules: {
        required: [(v) => !!v || "Este campo es requerido"],
        phone: [
          (v) => !!v || "El campo es requerido",
          (v) => v.length === 10 || "El número debe tener 10 dígitos",
          (v) => /^[0-9]+$/.test(v) || "Solo se permiten números",
        ],
      },
      userManager: UserManager,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      this.resetForm();
    },
    resetForm() {
      this.form = {
        name: "",
        phone: "",
        notes: "",
      };
      this.errorMessage = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorMessage = "";

      try {
        // Formateamos el número de teléfono con el prefijo +52
        const formattedPhone = `52${this.form.phone}`;

        // Preparamos los datos para enviar
        const data = {
          name: this.form.name,
          phone: formattedPhone,
          notes: this.form.notes,
        };

        // Llamada al servicio usando customerService (que ya incluye la captura en Sentry)
        const response = await CustomerService.referSupplier(data);

        // Procesamos la respuesta
        if (response.ok) {
          await response.json();

          // Enviamos un mensaje personalizado al diálogo de éxito
          this.$emit("showDialogAlert", {
            success: true,
            title: "¡Gracias por tu recomendación!",
            text: `Hemos recibido tu recomendación para ${this.form.name}. Nuestro equipo se pondrá en contacto con el proveedor en breve para invitarlo a unirse a nuestra plataforma y ampliar nuestra red de colaboradores.`,
          });

          this.closeDialog();
        } else {
          const error = await response.json();
          this.errorMessage =
            error.msg || "Ha ocurrido un error al enviar la recomendación";
        }
      } catch (error) {
        // El servicio ya captura los errores en Sentry
        this.errorMessage =
          "Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo.";
      } finally {
        this.loading = false;
      }
    },
    validateNumberInput(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
  },
};
</script>
